var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgPanelBlack = function SvgPanelBlack(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-6v2h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-2Zm8-12v10H5V5h14Z",
    fill: "#667695"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-.844a.1.1 0 0 1-.071-.17l.597-.598a.5.5 0 0 0 0-.707l-.707-.707a.5.5 0 0 0-.707 0l-.597.597a.1.1 0 0 1-.171-.07V6.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.844a.1.1 0 0 1-.17.071l-.598-.597a.5.5 0 0 0-.707 0l-.707.707a.5.5 0 0 0 0 .707l.597.597a.1.1 0 0 1-.07.171H8.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.844a.1.1 0 0 1 .071.17l-.597.598a.5.5 0 0 0 0 .707l.707.707a.5.5 0 0 0 .707 0l.597-.597a.1.1 0 0 1 .171.07v.845a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-.845a.1.1 0 0 1 .17-.07l.598.597a.5.5 0 0 0 .707 0l.707-.707a.5.5 0 0 0 0-.707l-.597-.597a.1.1 0 0 1 .07-.171h.845Zm-5-1a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
    fill: "#667695"
  })));
};

export default SvgPanelBlack;